export default "__VITE_ASSET__Db6kB4Pp__"